// extracted by mini-css-extract-plugin
export default {"container":"Project_container__5P+NH","title":"Project_title__4wfWp","description":"Project_description__H-JoA","button":"Project_button__n8xoF"};